import { protectedReq, axiosProtectedReq } from "../../helpers/requestHelper";
import { basicMsg, basicTimerMsg, msg as timerMsg, valMsg } from "../swal_msg";

const GLOBAL_ERRORS = {
    // errores genéricos
    'server-err': () => valMsg('error', 'Sucursal', 'Hubo un incidente en el servidor'),
    'request-err': () => valMsg('error', 'Sucursal', 'Hubo un incidente con la petición'),

    // registro de sucursal
    'miss': () => basicMsg('Falta información de sucursal'),
    'no-file': () => valMsg('warning', 'No registrada', 'No se envió correctamente la portada de sucursal'),
    'folder-not-created': () => valMsg('warning', 'No registrada', 'No se creó la carpeta para sucursal'),
    'image-not-saved': (context) => valMsg('warning', context, 'No se guardó la portada de la sucursal'),
    'branch-not-saved': () => basicMsg('No se pudo guardar la sucursal'),

    // actualización de sucursal
    'not-updated': () => valMsg('info', 'Sucursal', 'La sucursal no fue actualizada'),
    
    // // eliminación de sucursal
    'not-deleted': () => valMsg('warning', 'Sucursal', 'La sucursal no fue eliminada'),
};

export const branchList = async(setBranches, setSnackbarData) => {
    try {
        const resp = await protectedReq('branch/list');
        const body = await resp.json();
        if (!body.status) {
            if (body.msg === 'no-results')
                setSnackbarData(e => ({
                    ...e, open: true, message: 'Sin resultados'
                }));
            else {
                const runHandler = GLOBAL_ERRORS[resp.msg] || (() => basicMsg('No se recuperó lista de sucursales'));
                runHandler('Lista');
            }
            return;
        }
        
        setBranches(body.resp);
    } catch (err) {
        timerMsg('error', 'Sucursales',
        'No se ha podido carga lista de sucursales');
    };
};

export const saveBranchMainImage = async(values) => {
    try {
        const {
            businessHours, links: { facebook, google_maps, whatsapp },
            name, file, ...branch
        } = values;
        
        const formData = new FormData();
        formData.append('title', name);
        formData.append('file', file);
        Object.keys(branch).forEach(key => {
            formData.append(key, branch[key]);
        });
        formData.append('whatsappNumber', whatsapp.number);
        formData.append('whatsappMessage', whatsapp.message);
        formData.append('facebookUrl', facebook.url);
        formData.append('googleMapsPlaceId', google_maps.placeId);
        formData.append('googleMapsLatitude', google_maps.location.lat);
        formData.append('googleMapsLongitude', google_maps.location.lng);
        formData.append('businessHours', JSON.stringify(businessHours));
        const resp = await axiosProtectedReq('branch/save', formData, 'POST');
        if (!resp.status) {
            const runHandler = GLOBAL_ERRORS[resp.msg] || (() => basicMsg('No se guardó la sucursal'));
            runHandler('No registrada');
        }
        return resp.status;
    } catch (err) {
        basicTimerMsg('No se ha guardado la sucursal');
        return false;
    }
};

export const updateBranch = async(values, setAndReset) => {
    try {
        const {
            businessHours, links: { facebook, google_maps, whatsapp },
            name, file, ...branch
        } = values;
        
        const formData = new FormData();
        if (file) // se actualizó banner de sucursal
            formData.append('file', file);
        
        formData.append('title', name);
        Object.keys(branch).forEach(key => {
            formData.append(key, branch[key]);
        });
        formData.append('whatsappNumber', whatsapp.number);
        formData.append('whatsappMessage', whatsapp.message);
        formData.append('facebookUrl', facebook.url);
        formData.append('googleMapsPlaceId', google_maps.placeId);
        formData.append('googleMapsLatitude', google_maps.location.lat);
        formData.append('googleMapsLongitude', google_maps.location.lng);
        formData.append('businessHours', JSON.stringify(businessHours));
        const response = await axiosProtectedReq('branch/update', formData, 'POST');
        if (!response.status) {
            const runHandler = GLOBAL_ERRORS[response.msg] || (() => basicMsg('No se actualizó la sucursal'));
            runHandler('No actualizada');
            return;
        }
        const { resp: { imgId } } = response;
        setAndReset(imgId);
    } catch (err) {
        basicTimerMsg('No se ha actualizado la sucursal');
    }
};

export const deleteBranch = async(model, setSnackbarData) => {
    try {
        const resp = await protectedReq('branch/delete', model, 'DELETE');
        const body = await resp.json();
        const { status, msg } = body;
        if (!status) {
            const runHandler = GLOBAL_ERRORS[resp.msg] || (() => basicMsg('No se eliminó la sucursal'));
            runHandler('No eliminada');
        } else {
            if (msg === 'rsrc-not-deleted')
                setSnackbarData(e => ({
                    ...e, open: true, message: 'Banner NO eliminado'
                }));
        }
        return status;
    } catch (err) {
        basicTimerMsg('No se ha eliminado la sucursal');
        return false;
    }
};
